/**
 * Adapter System Exports
 * 
 * This file provides clean exports for the new adapter system while maintaining
 * backwards compatibility with the existing dataSourceAdapters.ts file.
 */

// Import what we need for the createAdapterSystem function
import { adapterFactory } from './AdapterFactory';
import { DjangoAdapter } from './DjangoAdapter';
import { FulcrumAdapter } from './FulcrumAdapter';

// Export interfaces and types
export * from './IDataSourceAdapter';

// Export factory and adapters
export { AdapterFactory, adapterFactory } from './AdapterFactory';
export { DjangoAdapter } from './DjangoAdapter';
export { FulcrumAdapter } from './FulcrumAdapter';

// Export shared utilities and constants
export * from './SharedAdapterUtils';

// Export convenience functions for easy migration
export const createAdapterSystem = () => {
  // Register adapters
  adapterFactory.registerAdapter('django', new DjangoAdapter());
  adapterFactory.registerAdapter('fulcrum', new FulcrumAdapter());
  adapterFactory.registerAdapter('external', new DjangoAdapter()); // Default fallback
  
  return adapterFactory;
};
